import React, { createContext, useContext, useEffect, useState } from "react";

const AllDivisionContext = createContext([]);

export const ApiProvider = ({ children }) => {
  const [mobileNo, setMobileNo] = useState(() => {
    // ✅ Load initial value from localStorage (if present)
    return localStorage.getItem("moblieNo") || "";
  });
  const [authTokens, setAuthTokens] = useState(() => {
    const savedTokens = localStorage.getItem("authTokens");
    return savedTokens
      ? JSON.parse(savedTokens)
      : { idToken: "", refreshToken: "" };
  });

  return (
    <AllDivisionContext.Provider
      value={{ mobileNo, setMobileNo, authTokens, setAuthTokens }}
    >
      {children}
    </AllDivisionContext.Provider>
  );
};

export const useAllProduct = () => {
  const context = useContext(AllDivisionContext);
  if (!context) {
    throw new Error("useAllProduct must be used within an ApiProvider");
  }
  return context;
};

export default AllDivisionContext;
